import React, { ReactNode } from "react";
import styled from "styled-components";
import { device } from "../styles/media-query";

const Container = styled.div`
  position: relative;
  display: inline-block;
`;

const TitleText = styled.div`
  ${device.mobile} {
    font-size: 4rem;
    line-height: 48px;
  }
  font-size: 8rem;
  font-weight: bold;
  color: white;
  line-height: 96px;
  display: inline-block;
`;

const RedDot = styled.div`
  width: 10px;
  height: 10px;
  background: #ea3d61;
  position: absolute;
  right: -13px;
  bottom: 18.5px;
  ${device.mobile} {
    right: -15px;
    bottom: 10px;
  }
  border-radius: 50%;
`;

interface Props {
  text: string | ReactNode;
}

function Title({ text }: Props) {
  return (
    <Container>
      <TitleText>{text}</TitleText>
      <RedDot />
    </Container>
  );
}

export default Title;
